import { type FC, useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { useSportUrlParams } from '@mwl/core-lib';
import ResetIcon from '@public/assets/common/icons/close.svg';
import SearchEmptyImage from '@public/assets/common/images/notFound.webp';
import { Button } from '@/components/Button/Button';
import { Image } from '@/components/Image/Image';
import { getAnalytics } from './SportSearchEmpty.analytics';
import type { SportSearchEmptyProps } from './SportSearchEmpty.types';
import styles from './SportSearchEmpty.module.scss';
const SportSearchEmpty: FC<SportSearchEmptyProps> = ({
  className
}) => {
  const {
    t
  } = useTranslation('sport');
  const {
    search,
    setFilters
  } = useSportUrlParams();
  const searchVariants = t('search_possible_variants', 'sport, country, championship, team, outright');
  const analitycsData = getAnalytics(search, searchVariants);
  const handleClear = useCallback(() => {
    setFilters({
      search: ''
    });
  }, [setFilters]);
  return <div className={cn(styles.root, className)} data-sentry-component="SportSearchEmpty" data-sentry-source-file="SportSearchEmpty.tsx">
      <Image src={SearchEmptyImage} alt="Search empty" className={cn(styles.searchEmptyIcon, styles.icon)} data-sentry-element="Image" data-sentry-source-file="SportSearchEmpty.tsx" />

      <div className={styles.textContent}>
        <p className={styles.text}>
          {t('no_results_found', 'No results were found for your request')}:{' '}
          <span className={styles.searchRequest}>{search}</span>
        </p>
        <p className={styles.text}>
          {t('search_possible_by', 'The search is possible by')}:{' '}
          <span className={styles.searchPossible}>{searchVariants}</span>
        </p>
      </div>

      <Button className={styles.button} as="button" variant="text" analytics={analitycsData} onClick={handleClear} fontWeight="bold" data-sentry-element="Button" data-sentry-source-file="SportSearchEmpty.tsx">
        <ResetIcon className={cn(styles.resetIcon, styles.icon)} data-sentry-element="ResetIcon" data-sentry-source-file="SportSearchEmpty.tsx" />
        {t('reset_search', 'Reset search results')}
      </Button>
    </div>;
};
export { SportSearchEmpty };